module.exports = __webpack_public_path__ + "2119bb2bdd7d24ef6e9f4bb8d165089f.svg";